import React from 'react'
import Withdrawal from '@commons/withdraw'

const Recieve = () => {
  return (
    <>
      <br />
      <Withdrawal status={'Approved'} />
    </>
  )
}

export default Recieve
